import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import * as FlatModels from "@medsurf/flat-models";

@Component({
    selector: 'medsurf-control-modal',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modal.control.component.html',
    styleUrls: ['./modal.control.component.scss'],
    standalone: false
})
export class ModalControlComponent {
  @ViewChild('confirm_delete_template', {static: true}) confirmDelete!: TemplateRef<any>;
  
  context: { dynamicDialogRef: DynamicDialogRef, dynamicDialogConfig: DynamicDialogConfig };
  readonly FlatModels = FlatModels;
  
  constructor(public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig) {
    this.context = { dynamicDialogRef, dynamicDialogConfig };
  }
}
